import { CookieCategories } from '../../models/usercentrics-cookiebot';

export const INITIAL_COOKIE_CONSENT_STATE: CookieCategories = {
  marketing: false,
  preferences: false,
  statistics: false,
} as const satisfies CookieCategories;
